import { createAction, props } from '@ngrx/store';

export const forgotPassword = createAction(
  '[ForgotPassword] Forgot Password',
  props<{ email: string; isRetry?: boolean }>(),
);

export const forgotPasswordSuccess = createAction(
  '[ForgotPassword] Forgot Password Success',
  props<{ email: string; isRetry?: boolean }>(),
);

export const forgotPasswordFailure = createAction('[ForgotPassword] Forgot Password Failure', props<{ error: any }>());
